import React from "react";
import { Refresh } from "@bloomberg/media-ui-icons";
import { DropdownOption } from "@bloomberg/media-ui-dropdown/types";
import Notification from "~components/Notification";
import { WrappedHeader } from "~components/WrappedHeader";
import { WrappedHeaderPlaceholder } from "~components/WrappedHeader/headerPlaceholder";
import { LOADING_STATE, WATCHLIST_FAILURE_TEXT } from "~constants/Portfolio";

interface Props {
  loadingState: string;
  watchlistOptions: DropdownOption[];
  selectedWatchlistOption?: DropdownOption;
  onWatchlistChange: (option: DropdownOption) => void;
  onRefresh: () => void;
}

export function WrappedHeaderSection({
  loadingState,
  watchlistOptions,
  selectedWatchlistOption,
  onWatchlistChange,
  onRefresh,
}: Props) {
  if (loadingState === LOADING_STATE.LOADING) {
    return <WrappedHeaderPlaceholder />;
  }

  if (loadingState === LOADING_STATE.FAILED) {
    return (
      <Notification
        text={WATCHLIST_FAILURE_TEXT}
        variant="lineBreak"
        title=""
        actionIcon={<Refresh />}
        actionText="Refresh"
        onActionClick={onRefresh}
      />
    );
  }

  return (
    <WrappedHeader
      watchlistOptions={watchlistOptions}
      selectedWatchlistOption={selectedWatchlistOption}
      onWatchlistChange={onWatchlistChange}
    />
  );
}
